import { useMonitor } from "@suse-o11y/signal";
import React from "react";

import { type FormatterUnit, toFormatter } from "~/tools/formatter-unit";

import { UnitPicker } from "../../_unit-picker";

import type { FormState } from "./form-state";

export interface WidgetUnitProps {
	className?: string;
	disabled?: boolean;
	unit: FormState;
	default: undefined | FormatterUnit;
}

export const WidgetUnit: React.FC<WidgetUnitProps> = ({ className, unit, disabled, default: defaults }) => {
	const monitor = useMonitor();

	return (
		<UnitPicker
			className={className}
			disabled={disabled}
			onChange={(input) => unit.setInput(input)}
			placeholder={toFormatter(defaults).name}
			unit={unit.getInput(monitor)}
		/>
	);
};
